import { type ThemeOptions } from "@mui/material/styles";

/**
 * Design System Font Sizes (2025)
 *
 * These are the values from figma:
 * x-large: 24px
 * large: 18px
 * normal: 15px
 * small: 12px
 * x-small: 11px
 *
 * Mapping to MUI Typography:
 * caption → x-small (11px)
 * body2 → small (12px)
 * body1 → normal (15px)
 * h6 → large (18px)
 * h5 → x-large (24px)
 */

export const muiThemeTypography: ThemeOptions["typography"] = () => ({
  fontFamily: '"Circular", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  // Captions and small text
  caption: {
    fontSize: "11px",
    lineHeight: 1.5, // Standard for body text
  },

  // Secondary body text
  body2: {
    fontSize: "12px",
    lineHeight: 1.5, // Standard for body text
  },

  // Primary body text (default)
  body1: {
    fontSize: "15px",
    lineHeight: 1.5, // Standard for body text
  },

  // Heading 6 - large (18px)
  h6: {
    fontSize: "18px",
    lineHeight: 1.3, // Tighter for headings
    fontWeight: 500,
  },

  // Heading 5 - x-large (24px)
  h5: {
    fontSize: "24px",
    lineHeight: 1.3, // Tighter for headings
    fontWeight: 500,
  },
});
